// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"315":"dd768481","332":"6399f1ef"}[chunkId] + ".css";
};